import * as React from "react";
import Logo from "../../assets/tomo_logo_black.svg";
import user_icon from "../../assets/user_icon.svg";

export default function Header({ style, className }) {
  return (
    <div
      style={style}
      className={`head-wrap w-full py-5 mb-8 sm:mb-12 ${className}`}
    >
      <div className="flex justify-between mx-auto items-center px-6">
        <div className="sm:mx-auto">
          <img src={Logo} />
        </div>
        <a
          className="absolute right-4 hover:underline"
          style={{ zIndex: 51 }}
          href="/dashboard#/login?redirect_uri=/"
          onClick={() => {
            window.localStorage.removeItem("jwt");
            window.localStorage.removeItem("plaid_link_token");
          }}
        >
            Sign out
        </a>
        <div className="flex flex-1 text-right justify-end items-center hidden sm:hidden">
          <div>
            Boost your cash back up to 20%{" "}
            <button className="bg-black text-white py-2 px-4 shadow-lg mx-2">
              Refer a Friend
            </button>
          </div>
          <div />
        </div>
      </div>
    </div>
  );
}

Header.defaultProps = {
  style: {},
  className: "",
};
